var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.013 5.37814L18.6479 8.06855L12.013 14.6838L9.37807 12.0567L16.013 5.37814Z",
    fill: "#F0B90A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.013 9.36618L22.6479 12.0566L12.013 22.6599L9.37807 20.0328L20.013 9.36618Z",
    fill: "#F0B90A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01299 13.3545L10.6479 16.0449L8.01299 18.672L5.37807 16.0449L8.01299 13.3545Z",
    fill: "#F0B90A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.013 13.3545L26.6479 16.0449L16.013 26.6482L13.3781 24.0211L24.013 13.3545Z",
    fill: "#F0B90A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusd);
export default __webpack_public_path__ + "static/media/busd.340f017f2a2bf5b8c970a752bcfdd057.svg";
export { ForwardRef as ReactComponent };